<template xmlns="http://www.w3.org/1999/html">
  <div>
    <section class="page-content page-seven-container">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center" style="font-size: 35px;">
                STATEMENT OF SERVICES
              <br>
                NO CONFLICT OF INTEREST
              </p>
            </article>
            <article class="input-section">
              <div>
                <label for class="orep-label mb-0 ml-1">
                  Today's Date: {{ formattedCurrentDate() }}
                </label>
                <label></label>
                <label for class="orep-label mb-0 ml-1">
                    To whom it may concern:
                </label>
              </div>
            </article>
            <article class="input-section form-section" v-if="checkServices('real estate agent')" >
              <div>
                <h5>
                  <strong>
                    Real Estate Services:
                  </strong>
                </h5>
                <p class="mb-3">
                  I have not and will not in the future inspect homes that I have done real estate
                  transactions or any other services on and have not or will not in the future do real estate
                  transactions, or any other services on homes I have inspected.
                </p>
                <p class="mb-3">
                  I understand that this policy provides no coverage for real estate sales, transactions,
                  property management, or other agent/broker services.
                </p>
              </div>
            </article>
            <article class="input-section form-section" v-if="checkServices('contractor')">
              <div>
                <h5>
                  <strong>
                    Contractor Services:
                  </strong>
                </h5>
                <p class="mb-3">
                  I have not and will not in the future inspect homes that I have performed contractor
                  services, repairs, maintenance, and/or remediation or any other services on and have
                  not or will not in the future perform contractor services, repairs, maintenance, and/or
                  remediation or any other services on homes I have inspected.
                </p>
                <p class="mb-3">
                  I understand that there is no coverage under this policy for contractor services, repairs,
                  maintenance, and/or remediation of any kind.
                </p>
              </div>
            </article>
            <article class="input-section form-section" v-if="checkServices('engineer')">
              <div >
                <h5>
                  <strong>
                    Engineering Services:
                  </strong>
                </h5>
                <p class="mb-3">
                  I have not and will not in the future inspect homes that I have done engineering services
                  on and have not or will not in the future do engineering services, or any other services
                  on homes I have inspected.
                </p>
                <p class="mb-3">
                  I understand that this policy does not provide coverage for engineering services.
                </p>
              </div>
            </article>
            <article class="input-section form-section"  v-if="checkServices('pest inspector')">
              <div >
                <h5>
                  <strong>
                    Pest Inspector/Applicator Services:
                  </strong>
                </h5>
                <p class="mb-3">
                  I have not and will not in the future inspect homes that I have performed pest services
                  on and have not or will not in the future perform pest services on homes I have
                  inspected.
                </p>
                <p class="mb-3">
                  I understand that all pest services, other than pest inspections, are excluded under this
                  policy.
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <div >
                <label for class="orep-label mt-2">
                  Sincerely,
                </label>
              </div>
              <div class="row pb-3">
                <div class="col-md-6">
                  <input
                    type="text"
                    name="servicesSignature"
                    placeholder="Type Your Name to Sign"
                    class="orep-text-input w-100"
                    v-model="quote.servicesSignature"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                  >
                  <span
                    v-show="errors.has('servicesSignature')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('servicesSignature') | filterText }}</span>
                  <label for class="orep-label-custom mt-2">
                    {{ quote.nameOfPrincipalHomeInspector }}
                  </label>
                  <label for class="orep-label-custom mt-2">
                    {{ quote.fullLegalNameOfApplicant }}
                  </label>
                  <label for class="orep-label-custom mt-2">
                    {{ quote.customer.address }}
                  </label>
                  <label for class="orep-label-custom mt-2">
                    {{ quote.customer.city }}, {{ quote.customer.state }} {{ quote.customer.zipCode }}
                  </label>

                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-5'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-6')"></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSevenIsValid"
              :class="{submitDisabled: !state.pageSevenIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS, STATUS} from "../../utils/constants";

export default {
  name: "home-inspector-7",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    quote() {
      return this.$store.state.homeInspector.quote;
    },
    state() {
      return this.$store.state.homeInspector;
    },
    errorMsg() {
      return this.$store.state.homeInspector.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/home-inspector-ibd/' || first === '/portal/home-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
        return 'IBD';
      }else if (first === '/portal/home-inspector-rws/' || first === '/portal/home-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
        return 'RWS';
      }else if (first === '/portal/home-inspector-spmga/' || first === '/portal/home-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
        return 'SPMGA';
      }
      else if (first === '/riskpro/home-inspector/' || first === '/RISKPRO/home-inspector/' || this.quote.customer.partnerName === 'RISKPRO'){
        return 'RISKPRO';
      }
      else {
        return 'OREP';
      }
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },
    checkServices(service) {
      return this.quote.applicantOrAssociateReportMode.includes(service);
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSevenIsValid = true;
          return;
        }
        this.state.pageSevenIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.quote.applicantPrincipleEsignatureDatetime).format('MM/DD/YYYY');
    },
    formSubmit() {
      this.loading = true;
      this.quote.status = STATUS.Submitted;
      this.quote.customer.appStatus = APP_STATUS.Completed;
      if (this.getApplicantType === 'IBD'){
        this.quote.customer.partnerName = 'IBD';
      }else if (this.getApplicantType === 'SPMGA') {
        this.quote.customer.partnerName = 'SPMGA';
      } else if (this.getApplicantType === 'RWS') {
        this.quote.customer.partnerName = 'RWS';
      } else if (this.getApplicantType === 'RISKPRO') {
        this.quote.customer.partnerName = 'RISKPRO';
      }else {
        this.quote.customer.partnerName = '';
      }
      this.$store.dispatch('homeInspector/createQuote');
    }

  },


  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
    }, 500);
  },

  components: {}
};
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>
